export const validateEmail = (email) => {
  if (!email?.trim()) return "Fill out this field";
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!regex.test(email)) return "Enter a valid email address";
  return "";
};

export const validateRequired = (value, message = "Fill out this field") => {
  if (!value?.trim()) return message;
  return "";
};

export const validatePhone = (phone) => {
  if (!phone?.trim()) return "Fill out this field";
  if (!/^\d{10}$/.test(phone)) return "Enter a valid 10-digit phone number";
  return "";
};

export const validateDropdown = (value, message = "Please select a topic") => {
  if (!value?.trim()) return message;
  return "";
};

export const validatePassword = (
  password,
  message = "Password must be at least 8 characters and include uppercase, lowercase, number, and special character"
) => {
  if (!password) return "Fill out this field";

  // Regex explanation:
  // (?=.*[a-z])    => at least one lowercase
  // (?=.*[A-Z])    => at least one uppercase
  // (?=.*\d)       => at least one number
  // (?=.*[@$!%*?&]) => at least one special character
  // .{8,}          => minimum 8 characters
  const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&]).{8,}$/;

  return regex.test(password) ? "" : message;
};
